import api from "./api";

export const addFuncIdToLog = funcId =>
  api.post({
    path: `/v1/returns/logs/${funcId}`,
  });
